module.exports = __webpack_public_path__ + "static/img/14003014.9145a997.png";